import request from '../utils/request'

// 分页查询新闻接口
export function getNewsList (data) {
  return request({
    url: `/api/v1/newsCenter/queryNewsPage/${data.languageType}`,
    data,
    method: 'post'
  })
}
// 根据主键查询新闻信息详情
export function queryNewsDetail (data) {
  return request({
    url: `/api/v1/newsCenter/queryNewsDetail/${data.newsId}/${data.languageType}`,
    data,
    method: 'get'
  })
}
// 查询合作品牌logo
export function getlogo (data) {
  return request({
    url: '/api/v1/index/queryBrandCooperation',
    data,
    method: 'post'
  })
}
// 查询合作品牌介绍
export function brandIntro (data) {
  return request({
    url: `/api/v1/index/queryBrandIntroduce/${data.languageType}`,
    data,
    method: 'post'
  })
}
// 查询企业信息
export function enterpriseInfo (data) {
  return request({
    url: `/api/v1/index/queryCorpInfoSummary/${data.languageType}`,
    data,
    method: 'post'
  })
}
// 查询首页KV
// export function queryKv (data) {
//   return request({
//     url: '/api/v1/index/queryKv/zh',
//     data,
//     method: 'post'
//   })
// }
export function queryKv (data) {
  return request({
    url: `/api/v1/index/queryKv/${data.languageType}`,
    data,
    method: 'post'
  })
}
// 查询业务介绍入口
export function businessIntro (data) {
  return request({
    url: `/api/v1/index/queryServiceEntrance/${data.languageType}`,
    data,
    method: 'post'
  })
}
// 查询推荐新闻
export function queryRecNews (data) {
  return request({
    url: `/api/v1/index/queryRecNews/${data.languageType}`,
    data,
    method: 'post'
  })
}
// 查询全部经销商
export function querySortDealer (data) {
  return request({
    url: '/api/v1/dealerNetwork/querySortDealer',
    data,
    method: 'post'
  })
}
// 星耀未来
export function starFuture (data) {
  return request({
    url: `/api/v1/responsibility/starFuture/${data.languageType}`,
    data,
    method: 'post'
  })
}
